import React, { useState, useEffect } from 'react';
import {
  ComposableMap,
  Geographies,
  Geography,
  ZoomableGroup
} from 'react-simple-maps';

// Default data and geo URL
const geoUrl = 'https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json';

const DEFAULT_COUNTRY_DATA = {
  US: '#ff5722',  // orange
  GB: '#4caf50',  // green
  JP: '#2196f3',  // blue
  BR: '#9c27b0',  // purple
  CA: '#ffc107',  // yellow
  DE: '#f44336',  // red
  FR: '#00bcd4',  // cyan
  IN: '#8bc34a',  // light green
  AU: '#673ab7',  // deep purple
  CN: '#e91e63'   // pink
};

const MapSection = () => {
  // State management
  const [countryData, setCountryData] = useState(DEFAULT_COUNTRY_DATA);
  const [loading, setLoading] = useState(false); // Set true if you want loading state
  const [tooltip, setTooltip] = useState({ show: false, content: '', x: 0, y: 0 });

  // Fetch data function (example)
  const fetchCountryData = async () => {
    try {
      // Replace with your actual API call
      // const response = await fetch('/api/country-data');
      // const data = await response.json();
      // setCountryData(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCountryData();
  }, []);

  return (
    <section className="map-section">
    
      <div className="map-container" style={{ width: 'auto', height: 'auto' }}>
        <ComposableMap projection="geoMercator">
          <ZoomableGroup zoom={1} center={[0, 20]}>
            <Geographies geography={geoUrl}>
              {({ geographies }) =>
                geographies.map((geo) => {
                  const countryCode = geo.properties.iso_a2;
                  const fillColor = countryData[countryCode] || '#e0e0e0';
                  
                  return (
                    <Geography
                      key={geo.rsmKey}
                      geography={geo}
                      fill={fillColor}
                      stroke="#FFF"
                      strokeWidth={0.5}
                      style={{
                        default: { outline: 'none',backgroundColor: 'grey' },
                        hover: { fill: '#607d8b', outline: 'none' },
                        pressed: { outline: 'none' },
                      }}
                      onMouseEnter={() => {
                        setTooltip({
                          show: true,
                          content: `${geo.properties.name}`,
                          x: window.event.clientX,
                          y: window.event.clientY
                        });
                      }}
                      onMouseLeave={() => {
                        setTooltip({ ...tooltip, show: false });
                      }}
                    />
                  );
                })
              }
            </Geographies>
          </ZoomableGroup>
        </ComposableMap>

        {tooltip.show && (
          <div 
            className="map-tooltip"
            style={{
              position: 'absolute',
              left: tooltip.x + 10,
              top: tooltip.y + 10,
              background: 'rgba(0,0,0,0.8)',
              color: '#fff',
              padding: '5px 10px',
              borderRadius: '4px',
              pointerEvents: 'none',
              zIndex: 100
            }}
          >
            {tooltip.content}
          </div>
        )}
      </div>
    </section>
  );
};

export default MapSection;